<template>
    <div class="space-y-3">
        <div
            v-if="selectedFile"
            class="flex flex-wrap items-center gap-3 rounded border border-bordergray-100 bg-white px-4 py-3"
        >
            <div class="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded border border-bordergray-100 bg-gray-50">
                <img
                    v-if="canRenderImage(selectedFile)"
                    :src="selectedFile.url"
                    :alt="selectedFile.name"
                    class="h-full w-full object-cover"
                >
                <svg-vue
                    v-else
                    :icon="resolveCmsFileIcon(selectedFile.extension)"
                    class="h-6 w-6 text-gray-400"
                ></svg-vue>
            </div>
            <div class="min-w-0 flex-1">
                <div class="truncate text-sm font-medium text-gray-900">{{ selectedFile.name }}</div>
                <div class="mt-1 truncate font-mono text-xs text-gray-400">{{ selectedFile.key }}</div>
            </div>
            <button
                class="btn-stage-secondary"
                type="button"
                :disabled="disabled"
                @click="pickerOpen = true"
            >
                {{ $t('Datei auswählen') }}
            </button>
            <button
                class="inline-flex cursor-pointer items-center justify-center text-gray-400 transition hover:text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
                type="button"
                :title="$t('Auswahl entfernen')"
                :aria-label="$t('Auswahl entfernen')"
                :disabled="disabled"
                @click="clearSelection"
            >
                <svg-vue class="h-4 w-4" icon="font-awesome.regular.xmark"></svg-vue>
            </button>
        </div>

        <div
            v-else
            class="flex items-center justify-between gap-4 rounded border border-dashed border-bordergray-100 bg-gray-50 px-4 py-3"
        >
            <div class="text-sm text-gray-400">{{ $t('Keine Datei ausgewählt') }}</div>
            <button
                class="btn-stage-secondary"
                type="button"
                :disabled="disabled"
                @click="pickerOpen = true"
            >
                {{ $t('Datei auswählen') }}
            </button>
        </div>

        <div v-if="loadError" class="text-xs text-red-500">
            {{ $t('Die gespeicherte CMS-Datei konnte nicht geladen werden.') }}
        </div>

        <cms-media-drawer
            :open="pickerOpen"
            selection-mode="file"
            :insert-label="$t('Auswählen')"
            @close="pickerOpen = false"
            @select="applySelection"
        />
    </div>
</template>

<script>
import CmsMediaDrawer from "@/components/cms/cms-media-drawer";
import { resolveCmsFileIcon } from "@/utils/cms-file-manager";

export default {
    name: "CmsFilePickerField",
    components: {
        CmsMediaDrawer,
    },
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            pickerOpen: false,
            selectedFile: null,
            loadError: false,
        };
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(value) {
                this.resolveSelectedFile(value);
            },
        },
    },
    methods: {
        resolveCmsFileIcon,
        async resolveSelectedFile(value) {
            const key = String(value || '').trim();
            this.loadError = false;

            if (!key) {
                this.selectedFile = null;
                return;
            }

            if (this.selectedFile?.key === key) {
                return;
            }

            try {
                const response = await axios.get('api/workspace/admin/cms/file-manager/options', {
                    params: {
                        keys: [key],
                    },
                });

                const file = Array.isArray(response.data?.files) ? response.data.files[0] : null;
                this.selectedFile = file || {
                    key,
                    name: key,
                    extension: '',
                    is_image: false,
                };
                this.loadError = !file;
            } catch (error) {
                this.selectedFile = {
                    key,
                    name: key,
                    extension: '',
                    is_image: false,
                };
                this.loadError = true;
            }
        },
        applySelection(file) {
            this.selectedFile = file || null;
            this.loadError = false;
            this.$emit('update:modelValue', String(file?.key || ''));
        },
        clearSelection() {
            this.selectedFile = null;
            this.loadError = false;
            this.$emit('update:modelValue', '');
        },
        canRenderImage(file) {
            return !!file && !!file.is_image && file.file_exists !== false && !!file.url;
        },
    },
};
</script>
